/* 🔴 W120 — HIS WORD, 2026-10-01 ~09:40: "community maybe even leave out for now and see later about it. So maybe even don't
 * include the page (and all that comes with it like setting up the profile) in the app and web app but keep the code, and we
 * see later about it."
 *
 * THE ONE SWITCH ON THE WEB (the phone's twin is `CommunityFeature.isIncluded`). The web has no feed and no directory; what
 * it carries of the Community is the public name (`Your public name`, `community_identities`, 0 live rows), the Requests
 * inbox (`coach_requests`, 0 live rows; a request already PENDING keeps its tab) and the prompt to publish the directory's
 * page. ⚠️ `Your page` STAYS WHOLE (Fable's ruling: a MIXED editor is kept): it also holds `How you set next week`
 * (`profiles.review_mode`, the review's own `MODE_LINK` lands there) — its directory fields are now read by nobody.
 * Every door asks THIS constant; nothing is deleted, and `true` puts every door back exactly as it was. */
export const COMMUNITY_INCLUDED = false;

/** F4: the account's first page holds only `How you set next week` (and Log Out) while the Community is out — named for
 *  what is left, in the shortest true word. */
export const COACH_PAGE_TITLE = COMMUNITY_INCLUDED ? "Your coaching page" : "Settings";
/** F11 (Fable): the page is titled `Settings`; its first TAB says what it holds — `Next week` — so the two never read twice. */
export const COACH_PAGE_TAB = COMMUNITY_INCLUDED ? "Your page" : "Next week";
